/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Filter = core.serialization.enum_([
    "valid",
    "error",
    "all",
    "none",
]);
